import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import { MARKETING_APROVADOR_PERMISSIONS } from '@/lib/marketing';

const MarketingIndex = lazy(() => import('./Index'));
const MarketingDashboard = lazy(() => import('./Dashboard'));
const MarketingForm = lazy(() => import('./Form'));
const MarketingAprovacoes = lazy(() => import('./Aprovacoes'));

export const marketingRoutes: RouteObject[] = [
    {
        path: '/marketing',
        element: (
            <ProtectedRoute permission="marketing.view">
                <MarketingIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: '/marketing/dashboard',
        element: (
            <ProtectedRoute permission="marketing.view">
                <MarketingDashboard />
            </ProtectedRoute>
        ),
    },
    {
        path: '/marketing/aprovacoes',
        element: (
            <ProtectedRoute anyOf={[...MARKETING_APROVADOR_PERMISSIONS]}>
                <MarketingAprovacoes />
            </ProtectedRoute>
        ),
    },
    {
        path: '/marketing/novo',
        element: (
            <ProtectedRoute permission="marketing.create">
                <MarketingForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/marketing/:id',
        element: (
            <ProtectedRoute permission="marketing.view">
                <MarketingForm />
            </ProtectedRoute>
        ),
    },
];
